import dynamic from 'next/dynamic';

export const CustomMobileInput = dynamic(
  () => import('components/customMobileInput/CustomMobileInput').then((mod) => mod.CustomMobileInput),
  {
    ssr: false,
  }
);
